module.exports = __webpack_public_path__ + "img/close.84c3c3b5.svg";